import { createSelector } from 'reselect';

import { ControlRootState } from '../ControlRootState';

const workflowState = (state: ControlRootState) => state.workflow;

export const fileStates = createSelector(
  [workflowState],
  (workflow) => workflow.fileStates,
);

export const selectLatestFileStateByFileId = createSelector(
  [fileStates, (_: ControlRootState, fileId: string | undefined) => fileId],
  (state, fileId) =>
    fileId
      ? state[fileId]?.value?.at(0) || {
          state: { name: undefined },
          module: {},
          stateDate: undefined,
        }
      : { state: { name: undefined }, module: {}, stateDate: undefined },
);
